import React, { useState } from 'react';
import { InstantSearch, Configure } from 'react-instantsearch-dom';
import useIsBrowser from 'hooks/useIsBrowser';
import useStoreDetails from 'hooks/useStoreDetails';
import UpdateZipcodeSidebar from 'components/consumer/UpdateZipcodeSidebar';
import Error404 from 'components/consumer/404';
import { StoreCatalogProductResults } from 'components/consumer/consumer-search/commons/helpers';
import JBSearchBox from 'components/consumer/consumer-search/components/JBSearchBox';
import { ALGOLIA_INDEX_NAME } from 'commons/constants';
import { searchClient } from 'components/essentials/AlgoliaSearchClient';
import useUserLocation from 'global-state/userLocation/useUserLocation';

const searchStateDefault = {
  configure: {
    facetFilters: '',
    facets: [],
  },
  hitsPerPage: 10,
  page: 1,
  query: '',
};

const AssociatePage = () => {
  const isBrowser = useIsBrowser();
  const [searchState, setSearchState] = useState({ ...searchStateDefault });
  const [isUpdateZipcodeOpen, updateZipcodeForm] = useState(false);
  const userLocation = useUserLocation();

  const storeDetails = useStoreDetails();

  const show404Page = isBrowser && !storeDetails;

  const incrementPageNum = () => {
    setSearchState(prevState => ({ ...prevState, page: prevState.page + 1 }));
  };

  const onQueryChange = updatedSearchState => {
    setSearchState(updatedSearchState);
    const resetIcon = document.querySelector('.ais-SearchBox-reset');
    if (
      !resetIcon ||
      (updatedSearchState?.query?.length > 0 &&
        resetIcon.style.visibility === 'visibility')
    ) {
      return;
    }
    if (updatedSearchState?.query?.length > 0) {
      // when user has typed something reset icon should be visible.
      resetIcon.style.visibility = 'visible';
    } else {
      resetIcon.style.visibility = 'hidden';
    }
  };

  const toggleUpdateZipCodeSidebar = () => {
    updateZipcodeForm(prev => !prev);
  };

  return (
    <>
      {show404Page && <Error404 />}
      {!show404Page && (
        <div className="mb-24 [&_.ais-SearchBox-reset]:invisible">
          <UpdateZipcodeSidebar
            isZipcodeFormOpen={isUpdateZipcodeOpen}
            onClose={toggleUpdateZipCodeSidebar}
          />
          <header className="flex justify-between items-center mt-[1.2rem] mx-4 mb-4">
            <div className="text-3xl font-bold">Catalog</div>
            <div className="flex items-center">
              <span className="text-base mr-[15px]">
                {`Shipping time based on ZIP: `}
                <span className="text-brand">{`${userLocation?.zip ||
                  storeDetails?.zipCode ||
                  ''}`}</span>
              </span>

              <div>
                <span
                  className="text-base font-bold inline-block bg-brand text-white cursor-pointer align-middle px-5 py-[5px] text-center no-underline"
                  role="button"
                  onClick={toggleUpdateZipCodeSidebar}
                  tabIndex={0}
                >
                  {' '}
                  Update ZIP{' '}
                </span>
              </div>
            </div>
          </header>
          <div className="associate-search-section">
            <InstantSearch
              searchClient={searchClient}
              searchState={searchState}
              indexName={ALGOLIA_INDEX_NAME.PRODUCTS}
              onSearchStateChange={onQueryChange}
            >
              <Configure
                query={searchState.query}
                hitsPerPage={searchStateDefault.hitsPerPage}
                facets={['*']}
                numericFilters=""
              />
              <JBSearchBox
                defaultRefinement={searchState.query}
                forPage="associate"
                placeholder="Search by product name, ID"
              />

              <div className="associate-product-results__container">
                <div className="associate-product-results__inner">
                  <InstantSearch
                    searchClient={searchClient}
                    searchState={searchState}
                    indexName={ALGOLIA_INDEX_NAME.PRODUCTS}
                    onSearchStateChange={onQueryChange}
                    key={searchState.query}
                  >
                    <Configure
                      query={searchState.query}
                      hitsPerPage={searchStateDefault.hitsPerPage}
                      facets={['*']}
                      numericFilters=""
                    />
                    <StoreCatalogProductResults onLoadMore={incrementPageNum} />
                  </InstantSearch>
                </div>
              </div>
            </InstantSearch>
          </div>
        </div>
      )}
    </>
  );
};
export default AssociatePage;
